import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Log } from 'ng2-logger';
import { AppService } from '../app.service';

const log = Log.create('Admin');

@Component({
  selector: 'edit-admin',
  styleUrls: ['admin.less'],
  templateUrl: 'admin.component.html',
})

export class AdminComponent implements OnInit, OnDestroy {
  constructor(
      private appService: AppService,
      private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.appService.headerData.title = 'Admin';
    this.appService.headerData.path = [];

    this.renderer.addClass(document.body, 'edit-section-admin');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'edit-section-admin');
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts